
import store from '../store/store';
import { INotificationType } from '../types';
import { firebase } from '../config/firebase.client';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, set, push, remove } from "firebase/database";
import { SEND_NOTIFICATION, EDIT_NOTIFICATIONS, FETCH_NOTIFICATIONS, SEND_NOTIFICATION_FAILED, SEND_NOTIFICATION_SUCCESS, FETCH_NOTIFICATIONS_FAILED, FETCH_NOTIFICATIONS_SUCCESS } from "../store/types";

export const fetchUserNotifications = () => (dispatch: any) => {

  const {
    auth,
    userNotificationsRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });

  const uid = auth?.currentUser?.uid;

  if (!uid) return;

  onValue(userNotificationsRef(uid), snapshot => {
    const data = snapshot.val();
    if (data) {
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_NOTIFICATIONS_FAILED,
        payload: "No data available."
      });
    }
  });
};

export const fetchNotifications = () => (dispatch: any) => {

  const {
    notifyRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });
  onValue(notifyRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();

      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });

      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_NOTIFICATIONS_FAILED,
        payload: "No data available."
      });
    }
  });
};

export const editNotifications = (notification: INotificationType, method: 'Add' | 'Delete' | 'EDIT') => (dispatch: any) => {
  const {
    notifyRef,
    notifyEditRef
  } = firebase;
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method, notification }
  });

  if (method === 'Add') {
    push(notifyRef, notification);
  } else if (method === 'Delete') {
    remove(notifyEditRef(notification.id));
  } else {
    set(notifyEditRef(notification.id), notification);
  }
}

export const sendNotification = (notification: INotificationType) => async (dispatch: any) => {
  dispatch({
    type: SEND_NOTIFICATION,
    payload: notification
  });

  const users = store.getState().usersdata.users;

  if (users && users.length > 0) {
    const arr = [];
    const addedTokens = new Set();

    for (const usr of users) {
      if (!usr.pushToken) continue;

      let shouldSend = false;

      if (notification.usertype === 'All' && notification.devicetype === 'All') {
        shouldSend = true;
      } else if (notification.usertype === 'All' && usr.userPlatform === notification.devicetype) {
        shouldSend = true;
      } else if (usr.usertype === notification.usertype && notification.devicetype === 'All') {
        shouldSend = true;
      } else if ((usr.usertype === notification.usertype && usr.userPlatform === notification.devicetype) || notification.usertype == 'All') {
        shouldSend = true;
      }

      if (shouldSend && !addedTokens.has(usr.pushToken)) {
        addedTokens.add(usr.pushToken);
        arr.push({
          to: usr.pushToken,
          title: notification.title,
          msg: notification.body,
        });
      }
    }

    if (arr.length > 0) {
      for (const item of arr) {
        RequestPushMsg(item.to, { title: item.title, msg: item.msg });
      }

      dispatch({
        type: SEND_NOTIFICATION_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: SEND_NOTIFICATION_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_user_match,
      });
    }
  } else {
    dispatch({
      type: SEND_NOTIFICATION_FAILED,
      payload: store.getState().languagedata.defaultLanguage.no_user_match,
    });
  }
};


export const removeUserNotification = (notificationId: INotificationType['id']) => (dispatch: any) => {
  const {
    auth,
    userNotificationsItemRef
  } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return;

  remove(userNotificationsItemRef(uid, notificationId));
}